import { api } from './api'
import {
  Deadline,
  DeadlineCreateRequest,
  DeadlineUpdateRequest,
  DeadlineFilter,
  DeadlineStats
} from '../types/deadline'
import { API_ENDPOINTS } from '../constants/api'

export const deadlineService = {
  // List deadlines with optional filters
  listDeadlines: async (filters?: DeadlineFilter): Promise<Deadline[]> => {
    const params = new URLSearchParams()
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params.append(key, value.toString())
        }
      })
    }
    const query = params.toString() ? `?${params.toString()}` : ''
    return api.get<Deadline[]>(`${API_ENDPOINTS.DEADLINES.BASE}${query}`)
  },

  // Get a single deadline by ID
  getDeadline: async (id: number): Promise<Deadline> => {
    return api.get<Deadline>(API_ENDPOINTS.DEADLINES.byId(id))
  },

  // Create a new deadline
  createDeadline: async (data: DeadlineCreateRequest): Promise<Deadline> => {
    return api.post<Deadline>(API_ENDPOINTS.DEADLINES.BASE, data)
  },

  // Update an existing deadline
  updateDeadline: async (id: number, data: DeadlineUpdateRequest): Promise<Deadline> => {
    return api.put<Deadline>(API_ENDPOINTS.DEADLINES.byId(id), data)
  },

  // Delete a deadline
  deleteDeadline: async (id: number): Promise<void> => {
    return api.delete(API_ENDPOINTS.DEADLINES.byId(id))
  },

  // Mark deadline as completed
  markCompleted: async (id: number): Promise<Deadline> => {
    return api.post<Deadline>(API_ENDPOINTS.DEADLINES.complete(id))
  },

  // Mark deadline as pending
  markPending: async (id: number): Promise<Deadline> => {
    return api.post<Deadline>(API_ENDPOINTS.DEADLINES.pending(id))
  },

  // Get upcoming deadlines (within next 7 days)
  getUpcomingDeadlines: async (limit?: number): Promise<Deadline[]> => {
    const params = new URLSearchParams()
    if (limit) params.append('limit', limit.toString())
    const query = params.toString() ? `?${params.toString()}` : ''
    return api.get<Deadline[]>(`${API_ENDPOINTS.DEADLINES.UPCOMING}${query}`)
  },

  // Get overdue deadlines
  getOverdueDeadlines: async (): Promise<Deadline[]> => {
    return api.get<Deadline[]>(API_ENDPOINTS.DEADLINES.OVERDUE)
  },

  // Get deadline statistics
  getStats: async (): Promise<DeadlineStats> => {
    return api.get<DeadlineStats>(API_ENDPOINTS.DEADLINES.STATS)
  }
}